<template>
<div>
    <section class="first-view n-if-pc">
      <div class="d-flex justify-center container">
        <img src="../assets/img/first_img.png" alt="">
        <div class="text-center d-flex align-center">
          <div>
            <h1 class="text-left">
              宅配買取・出張買取<br>
              買取専門店<br>
              <span class="text-primary">Recycle+</span>
            </h1>
            <div class="mt-6 d-flex justify-center px-3">
                <price-card class="mr-1">査定</price-card>
                <price-card class="mr-1">手数料</price-card>
                <price-card class="mr-1">送料</price-card>
                <price-card class="">配送</price-card>
            </div>
            <div class="mt-5">
              <b>
                今なら、LINE査定お申し込みで、<br>
                買取査定額<strong>10%UP</strong>キャンペーン実施中！
              </b>
            </div>
            <div class="mt-1">
              <a href="https://lin.ee/39zrDj9">
                <div class="sm-line-btn">今すぐLINE査定</div>
              </a>
            </div>
            <div class="mt-1">
              <b>簡単<strong>3ステップ</strong>!最短<strong>5分</strong>で仮査定!</b>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="n-if-sp first-view">
        <img src="@/assets/img/first_img_sp.png" alt="">
        <div class="px-3 pt-3 first-text">
            <h1 class="text-left">
                宅配買取・出張買取<br>買取専門店<br><strong>Recycle+</strong>
            </h1>
        </div>
        <div class="d-flex justify-center first-prices pb-2">
            <price-card class="mr-1">査定</price-card>
            <price-card class="mr-1">手数料</price-card>
            <price-card class="mr-1">送料</price-card>
            <price-card class="">配送</price-card>
        </div>
    </section>
    <section class="n-if-sp">
      <div class="mt-2">
        <b>
          今なら、LINE査定お申し込みで、<br>
          買取査定額<strong>10%UP</strong>キャンペーン実施中！
        </b>
      </div>
      <div class="mt-1">
        <a href="https://lin.ee/39zrDj9">
          <div class="sm-line-btn">今すぐLINE査定</div>
        </a>
      </div>
      <div class="mt-1">
        <b>簡単<strong>3ステップ</strong>!最短<strong>5分</strong>で仮査定!</b>
      </div>
      <div class="mt-3">
        <b>買取は納得した査定金額が付かなければ<br>無料でキャンセルも可能！</b>
      </div>
    </section>
</div>
</template>

<script>
import PriceCard from '@/components/PriceCard.vue'
export default {
    components:{
        PriceCard
    }
}
</script>